__turbopack_context__.v({
  "addProfileIcon": "Submenu-module__Fh0n_a__addProfileIcon",
  "closeWrapper": "Submenu-module__Fh0n_a__closeWrapper",
  "container": "Submenu-module__Fh0n_a__container",
  "contentWrapper": "Submenu-module__Fh0n_a__contentWrapper",
  "profileName": "Submenu-module__Fh0n_a__profileName",
  "profileWrapper": "Submenu-module__Fh0n_a__profileWrapper",
  "profilesWrapper": "Submenu-module__Fh0n_a__profilesWrapper",
  "profilesWrapper__firstRow": "Submenu-module__Fh0n_a__profilesWrapper__firstRow",
  "profilesWrapper__secondRow": "Submenu-module__Fh0n_a__profilesWrapper__secondRow",
  "selected": "Submenu-module__Fh0n_a__selected",
});
